var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"d-flex align-center justify-center fill-height",attrs:{"dark":""}},[_c('div',[_c('h1',{staticClass:"font-weight-light"},[_vm._v("Error 404: Page not found")])])])}
var staticRenderFns = []

export { render, staticRenderFns }